<template>
    <ion-button
        class="base-button"
        :button-type="buttonType"
        :color="color"
        :disabled="disabled"
        :download="download"
        :expand="expand"
        :fill="fill"
        :href="href"
        mode="ios"
        :rel="rel"
        :router-animation="routerAnimation"
        :router-direction="routerDirection"
        :shape="shape"
        :size="size"
        :strong="strong"
        :target="target"
        :type="type"
        @ionBlur="$emit('blur')"
        @ionFocus="$emit('focus')"
    >
        <div slot="start" class="center" v-if="$slots['start']">
            <slot name="start"/>
        </div>

        <slot/>

        <div slot="end" class="center" v-if="$slots['end']">
            <slot name="end"/>
        </div>

        <div slot="icon-only" v-if="$slots['icon-only']">
            <slot name="icon-only"/>
        </div>
    </ion-button>
</template>

<script setup lang="ts">
import { IonButton } from "@ionic/vue";
import { computed } from "vue";

import { BUTTON_TYPE, ION_ROUTER_DIRECTION, ION_VARIANT } from "@/types/enum/ionicEnum";
import { IonButtonProps } from "@/types/props";
import { IonButtonEmits } from "@/types/emits";

const props = withDefaults(defineProps<IonButtonProps>(), {
    buttonType: BUTTON_TYPE.BUTTON,
    disabled: false,
    routerDirection: ION_ROUTER_DIRECTION.FORWARD,
    strong: false,
    type: BUTTON_TYPE.BUTTON,
    color: ION_VARIANT.CORAL
})

defineEmits<IonButtonEmits>();

const height = computed(() => props.height ? props.height + 'px' : '50px');
</script>

<style scoped>
.base-button.button-outline {
    --background: tranparent;
    --background-activated: transparent;
    --background-focues: transparent;
    --background-hover: transparent;
}

.base-button.inherit-color::part(native) {
    color: inherit;
}

.base-button.inherit-border-color::part(native) {
    border-color: var(--color);
}
</style>

<style scoped lang="scss">
@use '@/theme/mixin.scss';

.base-button {
  border-radius: 5em;
  --border-radius: 5em;
  height: v-bind(height);
  max-width: 300px !important;
}

.base-button.shadow {
    @include mixin.light {
        box-shadow: 0 2px 2px 0 var(--light-shadow);
    }

    @include mixin.dark {
        box-shadow: none;
    }
}
</style>
